import attribution from '../frontend/modules/attribution';
import '../styles/styles.scss';

attribution();
